import React, { Component } from "react";
import "./SideBar.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import avatarIcon from "../../assets/default-avatar.png";
import * as actionCreators from "../../modules/actions/index";
import awardIcon from "../../assets/awardIcon.svg";
import {
  profilePicValidityCheck,
  renderGenderPronoun,
} from "../../utils/constants";

class ActivityBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUserShown: false,
      user: this.props.member,
      idx: this.props.idx,
    };
  }

  componentWillReceiveProps(nextProps) {
    let { activity } = this.state;
    if (nextProps.user !== this.state.user) {
      this.setState({
        user: nextProps.user,
        idx: nextProps.idx,
      });
    }
  }

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  isUserTip = () => {
    this.setState((prevState) => ({
      isUserShown: !prevState.isUserShown,
    }));
  };

  gotoProfile = () => {
    let { member } = this.props;
    this.props.history.push(
      `/home/${member.organizationId}/profile/${member._id}`
    );
  };

  render() {
    let { member, idx, isSpotlight } = this.props;
    let { isUserShown } = this.state;
    // console.log(member)

    return (
      <div
        className={
          idx !== 0
            ? "displayInlineBlock activityBarImgContainer ml-8"
            : "displayInlineBlock activityBarImgContainer"
        }
        onMouseEnter={() => this.isUserTip()}
        onMouseLeave={() => this.isUserTip()}
        onClick={() => this.gotoProfile()}
      >
        {isSpotlight ? (
          <div className="spotlightContent">
            {/* <img src={awardIcon} class="awardSpotlight" /> */}
            {profilePicValidityCheck(member.profilePic) ? (
              <img
                src={member.profilePic ? member.profilePic : avatarIcon}
                className="spotlightImage"
              />
            ) : (
              <span
                className="spotlightUserInitials"
                data-letters={this.getInitials(member)}
              ></span>
            )}

            <div className="userNameList">
              {member.firstName} {member.lastName}
              <div className="user_gender_pronoun_sidebar">
                {renderGenderPronoun(member)}
              </div>
            </div>

            <img src={awardIcon} className="awardSpotlight" />

            <span className="visbilityHidden">
              <div>
                Icons made by
                <a
                  href="https://www.flaticon.com/free-icon/medal_744922?term=award&page=1&position=16"
                  title="Vectors Market"
                >
                  Vectors Market
                </a>{" "}
                from{" "}
                <a href="https://www.flaticon.com/" title="Flaticon">
                  www.flaticon.com
                </a>
              </div>
            </span>
          </div>
        ) : (
          <span>
            {  profilePicValidityCheck(member.profilePic) ? (
              <img
                src={member.profilePic ? member.profilePic : avatarIcon}
                className="spotlightImage"
              />
            ) : (
              <span
                className="spotlightUserInitials"
                data-letters={this.getInitials(member)}
              ></span>
            )}
            {/* <img src={member.profilePic? member.profilePic: avatarIcon}/> */}
            <div className={isUserShown ? "userNameList" : "visbilityHidden"}>
              {member.firstName} {member.lastName}
            </div>
          </span>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.profile,
    activity: state.user.profile.activity,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setStoryActivity: (data) => dispatch(actionCreators.setStoryActivity(data)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ActivityBar)
);
